import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/pages"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function MovementList (){
  const {user} = useUser()
  let view = contentLayout[modules.MovementList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.MovementList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.MovementList}></Index>
 )
}

export default MovementList